import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface FilterData {
  filterFarm: number | null;
  filterProduct: string;
  filterBatch: string;
  filterValidity: Date;
  filterMode: string;
  filterCreatedAt: Date;
  filterUpdatedAt: Date;
  filterStockDate: Date;
  filterRegional: number | null;
  farms: any[];
  products: any[];
  regionals: { id: number; name: string }[];
}

@Component({
  selector: 'app-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss'],
})
export class FilterDialogComponent {
  filterData: FilterData;
  filteredFarms: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<FilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FilterData
  ) {
    this.filterData = {
      ...data,
      filterRegional: data.filterRegional ?? null,
      filterFarm: data.filterFarm ?? null,
    };

    this.filterData.products.sort((a, b) => {
       return a.description.localeCompare(b.description);
    });
    
    this.updateFilteredFarms();
  }

  updateFilteredFarms(): void {
    const regionalId = this.filterData.filterRegional;

    console.log('[DEBUG] Regional selecionada:', regionalId);
    console.log('[DEBUG] Todas as fazendas:', this.filterData.farms);

    this.filteredFarms = regionalId
      ? this.filterData.farms.filter(f => f.territory?.regional_id === regionalId)
      : this.filterData.farms;

    // Limpa seleção de fazenda se não pertencer mais à regional
    if (
      this.filterData.filterFarm &&
      !this.filteredFarms.some(f => f.id === this.filterData.filterFarm)
    ) {
      this.filterData.filterFarm = null;
    }

    console.log('[DEBUG] Fazendas visíveis após filtro:', this.filteredFarms);
  }

  compareById = (a: any, b: any): boolean => a === b;

  onApply(): void {
    this.dialogRef.close(this.filterData);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
